import type * as React from 'react';
import { put } from '@Domain/Api';
import type { AiModelPayload } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelsFetched';
import aiModelUpdated, {
	type AiModelUpdatedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelUpdated';
import aiModelUpdateFailed, {
	type AiModelUpdateFailedAction,
} from '@Application/Ai/AiConfiguration/Models/Actions/aiModelUpdateFailed';
import type UpdateAiModel from '@Application/Ai/AiConfiguration/Models/Commands/UpdateAiModel';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiModelUpdatedAction | AiModelUpdateFailedAction;

export default (command: UpdateAiModel) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<AiModelPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-models/${command.modelId}`,
				command.toJSON(),
			);

			const action = aiModelUpdated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiModelUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
